import baseURL from "../common/axios";
class WhatsAppCommunicationService {
  //To Insert WhatsAppCommunication-->MOPCRM API
  create(dataModel) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post(
      "WhatsAppCommunication/Create",
      dataModel
    );
  }
  //To Insert WhatsApp Template-->MOPCRM API
  createTemplate(dataModel) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post(
      "WhatsAppCommunication/CreateWithTemplate",
      dataModel
    );
  }
  //To Insert WhatsApp Document/Images/Audio/Sticker-->MOPCRM API
  createMedia(dataModel) {
    debugger;
    return baseURL.httpMSMOPCRMUrl.post(
      "WhatsAppCommunication/CreateWithMedia",
      dataModel
    );
  }
  //To Update WhatsAppCommunication-->MOPCRM API
  update(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post(
      "WhatsAppCommunication/Update",
      dataModel
    );
  }
  //To Insert WhatsAppCommunication-->MOPCRM API
  clicktocall(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post(
      "WhatsAppCommunication/ClickToCall",
      dataModel
    );
  }
  //To Insert WhatsAppCommunication-->MOPCRM API
  clicktoCallOptions(dataModel) {
    return baseURL.httpMSMOPCRMUrl.post(
      "WhatsAppCommunication/CallOptions",
      dataModel
    );
  }
  //To Delete WhatsAppCommunication-->MOPCRM API
  delete(Id) {
    return baseURL.httpMSMOPCRMUrl.delete(
      "WhatsAppCommunication/Delete?id=" + Id
    );
  }
  //Active
  active(Id, Status) {
    return baseURL.httpMSMOPCRMUrl.put(
      "WhatsAppCommunication/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  //To Get WhatsAppCommunication List-->MOPCRM API
  getList() {
    return baseURL.httpMSMOPCRMUrl.get("WhatsAppCommunication/List");
  }
  //To Update WhatsApp Read Message-->MOPCRM API
  UpdateWhatsAppRead(Id, Type) {
    return baseURL.httpMSMOPCRMUrl.put(
      "WhatsAppCommunication/UpdateWhatsAppReadStatus?Id=" +
        Id +
        "&Type=" +
        Type +
        ""
    );
  }
  //To Get WhatsAppCommunication List-->MOPCRM API
  getByContactsId(Id) {
    return baseURL.httpMSMOPCRMUrl.get(
      "WhatsAppCommunication/ListWhatsAppCommunicationByContactId?id=" + Id + ""
    );
  }
  getLeadsId(Id) {
    return baseURL.httpMSMOPCRMUrl.get(
      "WhatsAppCommunication/ListWhatsAppCommunicationByLeadsId?id=" + Id + ""
    );
  }
  getById(Id) {
    return baseURL.httpMSMOPCRMUrl.get(
      "WhatsAppCommunication/Get?id=" + Id + ""
    );
  }

  //Whatsapp List by AgentId
  WhatsappListbyAgentId(AgentId, IsAdmin) {
    return baseURL.httpMSMOPCRMUrl.get(
      "WhatsAppCommunication/WhatsAppContactsList?AgentId=" +
        AgentId +
        "&IsAdmin=" +
        IsAdmin +
        ""
    );
  }
}
export default new WhatsAppCommunicationService();
